import { DocumentIcon } from '@heroicons/react/24/outline'
import { intlFormat } from 'date-fns'
import { useState } from 'react'

import { useGetDataDeletionRequestsQuery } from '../../app/apiSlice'
import { LINK_SUPPORT } from '../../app/constants'
import { AdminDataTableSection, AdminPage, AdminPageHeader, Loader } from '../../common/components'
import { Button, LinkButton, Table } from '../../common/designs'
import UpdateDataDeletionRequest from './UpdateDataDeletionRequest'
import { DataDeletionRequestState, DeletionScopeEnum } from './types'

const DataDeletion = () => {
  const { data, isLoading } = useGetDataDeletionRequestsQuery()

  const [requestIdSelected, setRequestIdSelected] = useState<null | number>(null)

  if (isLoading) return <Loader />

  return (
    <AdminPage width='full'>
      <AdminPageHeader
        title='Data Deletion'
        description='Review and manage company and team level data deletion requests.'
      />
      <AdminDataTableSection>
        <Table
          label='Data Deletion Requests'
          description={
            <>
              Self-service data deletion is temporarily unavailable. To request data deletion, please
              contact{' '}
              <a
                href={LINK_SUPPORT}
                target='_blank'
                rel='noopener noreferrer'
                className='font-medium text-primary-600 underline decoration-primary-600 hover:text-primary-700'
              >
                support
              </a>
              .
            </>
          }
          action={
            <Button variant='destructive' iconStart={<DocumentIcon />} disabled>
              Request Data Deletion
            </Button>
          }
          head={[
            'State Of Request',
            'Data To Be Deleted',
            'Request Created At',
            'Request By User',
            'Actions',
          ]}
          body={[
            ...(data ?? []).map((dp) => {
              return [
                dp.state,
                dp.deletion_scope === DeletionScopeEnum.COMPANY
                  ? DeletionScopeEnum.COMPANY
                  : `${DeletionScopeEnum.TEAM} (${dp?.team_name})`,
                intlFormat(new Date(dp.requested_at_timestamp), {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                }),
                dp.requested_by_user_full_name,
                dp.state === DataDeletionRequestState.PENDING ? (
                  <LinkButton
                    key={`${dp.requested_at_timestamp}-${dp.requested_by_user_full_name}`}
                    onClick={() => setRequestIdSelected(dp.id)}
                  >
                    Cancel Request
                  </LinkButton>
                ) : null,
              ]
            }),
          ]}
        />
      </AdminDataTableSection>

      <UpdateDataDeletionRequest
        open={Boolean(requestIdSelected)}
        onClose={() => setRequestIdSelected(null)}
        id={requestIdSelected}
      />
    </AdminPage>
  )
}

export default DataDeletion

